import { render, staticRenderFns } from "./ModalRefillBalance.vue?vue&type=template&id=4f189120&scoped=true&"
import script from "./ModalRefillBalance.vue?vue&type=script&lang=ts&"
export * from "./ModalRefillBalance.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRefillBalance.vue?vue&type=style&index=0&id=4f189120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f189120",
  null
  
)

export default component.exports